import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "item", "prevButton", "nextButton"];
  static values = {
    itemsPerView: Number,
    totalItems: Number,
  };

  initialize() {
    this.currentIndex = 0;
    this.maxItemsPerView = this.itemsPerViewValue;
    this.itemsMinWidth = 0;

    if (this.hasItemTarget) {
      const itemElement = this.itemTargets[0].firstElementChild || this.itemTargets[0];
      this.itemsMinWidth = parseFloat(getComputedStyle(itemElement).minWidth) + 16; // 16px (8 + 8) for padding
    }
  }

  connect() {
    if (!this.hasItemTarget) return;

    this.updateItemsPerView();
    this.refreshControls();
    window.addEventListener("resize", this.updateItemsPerView.bind(this));
  }

  next() {
    const maxIndex = this.totalItemsValue - this.itemsPerViewValue;
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.moveTrack();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.moveTrack();
    }
  }

  moveTrack() {
    const shiftPerItem = 100 / this.itemsPerViewValue;
    const shiftPercentage = -(this.currentIndex * shiftPerItem);
    this.trackTarget.style.transform = `translateX(${shiftPercentage}%)`;
    this.refreshControls();
  }

  updateItemsPerView() {
    const containerWidth = this.trackTarget.offsetWidth;
    let newItemsPerView = Math.floor(containerWidth / this.itemsMinWidth) || 0;

    if (newItemsPerView < 1) {
      newItemsPerView = 1;
    }

    newItemsPerView = Math.min(newItemsPerView, this.maxItemsPerView);

    this.itemsPerViewValue = Math.min(newItemsPerView, this.totalItemsValue);
    this.itemTargets.forEach((item) => {
      item.style.width = `${100 / this.itemsPerViewValue}%`;
    });

    const maxIndex = this.totalItemsValue - this.itemsPerViewValue;
    if (this.currentIndex > maxIndex) {
      this.currentIndex = maxIndex < 0 ? 0 : maxIndex;
    }

    this.moveTrack();
  }

  refreshControls() {
    const maxIndex = this.totalItemsValue - this.itemsPerViewValue;
    const allItemsFit = this.totalItemsValue <= this.itemsPerViewValue;

    this.prevButtonTarget.disabled = this.currentIndex <= 0;
    this.nextButtonTarget.disabled = this.currentIndex >= maxIndex;

    const hideButtons =
      allItemsFit || (this.prevButtonTarget.disabled && this.nextButtonTarget.disabled);

    this.prevButtonTarget.classList.toggle("hidden", hideButtons);
    this.nextButtonTarget.classList.toggle("hidden", hideButtons);
  }
}
